<span class="loading" *ngIf="loading">
  <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bar></app-side-menu-bar>
<div class="main-content">
  <div class="heading">
    <!-- <span><label class="heading-text">Exchange Rate</label></span> -->
    <span class="exchangeRateUpload" [ngClass]="{disabledDiv: !isActiveDiv}" *ngIf="isActiveDiv"> 
      <button type="button" class="btn btn-primary exchangeRateExcel-upload">
        <label for="currencyfiles" style="cursor:pointer;font-weight:400;">{{exchangeRateUpload}} <i
            class="upload-icon"></i></label>
        <input id="currencyfiles" #currencyfiles style="visibility:hidden;" (click) = "confirmation()" (change)="uploadCurrencyExchangeRate($event.target.files)"
          class="upload-icon" type="file">
      </button>
    </span>
  </div>
  <br/>

  <div class="progressBarPlaceholder" *ngIf="showProgress">
    <div class="progressBar" >
      <mat-progress-bar mode="determinate" value={{progressValue}}></mat-progress-bar>
    </div>
  </div>
  <div class="alert alert-success successMsg" *ngIf="showSuccess">
    {{uploadinserted}} <br />
    {{uploadrejected}} <br />
    {{uploadduplicated}}
  </div>
  <div class="alert alert-danger failMsg" *ngIf="showFileValidation">
    {{fileValidationMsg}}
  </div>
  <div>
    <div *ngIf="noRecordsShow" class="records">{{noRecords}}</div>
    <div class="example-container">
      <mat-paginator #paginator 
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 20,30]"
                showFirstLastButtons>
        </mat-paginator>
      <table mat-table [dataSource]="dataSource" [hidden]="noRecordsShow">

        <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
        <!-- Cluster Column -->
        <ng-container matColumnDef="Cluster">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Cluster </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.cluster}} </td>
        </ng-container>



        <!-- Country Column -->
        <ng-container matColumnDef="Country">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Country </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element">
            <span>{{element.country}}</span>
          </td>
        </ng-container>

        <!-- Site Column -->
        <ng-container matColumnDef="Site">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Site </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.site}} </td>
        </ng-container>

        <!-- Currency Unit Column -->
        <ng-container matColumnDef="Currency Unit">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Currency Unit </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.currencyunit}} </td>
        </ng-container>

        <!-- Currency Code Column -->
        <ng-container matColumnDef="Currency Code">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Currency Code </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.currencycode}} </td>
        </ng-container>

        <!-- Euro Exchange Rate Column -->
        <ng-container matColumnDef="Euro Exchange Rate">
          <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef>Euro Exchange Rate</th>
          <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.euroexchangerate}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>